/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react'
import Select from 'react-select'
import './GenXDropdown.css'
import LanguageStrings from '../i18n/locales'
import { customStyles } from './AsyncGenXDropdown'

const ComponentStrings = LanguageStrings().Components

export interface Option {
  value: string
  label: string
}

const injectLabel = (label: string | undefined): JSX.Element => {
  return <span style={{ fontSize: '15px', paddingBottom: 10 }}>{label}</span>
}

interface GenXDropdownProps {
  options: Option[]
  value: Option | null
  onSelect: (selectedValue: Option, index?: number) => void
  placeholder?: string
  width?: number | string
  height?: number
  label?: string
  disabled?: boolean
}

export function GenXDropdown ({ options, onSelect, value, placeholder, width, label, height, disabled }: GenXDropdownProps): JSX.Element {
  const handleChange = (selectedOption: Option, index?: number): void => {
    if (selectedOption != null) {
      onSelect(selectedOption, index)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {label !== undefined && injectLabel(label)}
      <Select
        isDisabled={disabled}
        value={value}
        options={options}
        classNames={{
          option: (props) => {
            return (props.data !== null && props.data !== undefined && (props.data as { label?: string }).label !== undefined && (props.data as { label?: string }).label !== undefined) ? `${(props.data as { label?: string }).label}-option` : 'genx-dropdown-option'
          }
        }}
        isSearchable
        inputId={`genx-dropdown ${label}-genx-dropdown`}
        maxMenuHeight={height !== undefined ? height : 150}
        // @ts-expect-error - typescript is not able to determine the type
        onChange={handleChange}
        placeholder={placeholder !== undefined ? placeholder : ComponentStrings.SelectAnOption}
        unstyled
        styles={customStyles(width, disabled)}
        menuPortalTarget={document.body} // Render menu in a portal at the document body
        menuPosition="fixed" // Use fixed positioning for menus
        menuPlacement="auto" // Auto place the menu to avoid screen boundaries
        theme={(theme: any) => ({
          ...theme,
          borderRadius: 0,
          height: 40,
          colors: {
            ...theme.colors,
            primary25: 'hotpink',
            neutral0: '#404040'
          }
        })}
      />
    </div>
  )
}
